var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('folder-selector',{attrs:{"folders":_vm.folders,"can-edit":_vm.isManager || _vm.privateCollateralEnabled},on:{"change-folder":_vm.onChangeFolder,"create":_vm.onCreateFolder,"delete":_vm.onDeleteFolder}})}
var staticRenderFns = []

export { render, staticRenderFns }